export default function logoutLinkDirective($window, environment) {
  'ngInject';
  return {
    restrict: 'A',
    link: function ($scope, $element) {
      $element.on('click', function(){
        $window.location.href = `${environment.site.parent}/logout`;
      });
    }
  };
}




/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/logoutLink.directive.js
 **/